import ProfitableGoingConcern, {
  profitableGoingConcernRoutes,
} from './subrouters/ProfitableGoingConcern/router';
import UnderExternalAdministration, {
  underExternalAdministrationRoutes,
} from './subrouters/UnderExternalAdministration/router';

export default [
  {
    path: 'profitable-going-concern/:id',
    element: ProfitableGoingConcern,
    routes: profitableGoingConcernRoutes,
    labelId: 'profitableGoingConcern',
  },
  {
    path: 'under-external-administration/:id',
    element: UnderExternalAdministration,
    routes: underExternalAdministrationRoutes,
    labelId: 'underExternalAdministration',
  },
] as Array<any>;
